import { render, staticRenderFns } from "./TimelineBreaksArea.vue?vue&type=template&id=823784a6&"
import script from "./TimelineBreaksArea.vue?vue&type=script&lang=js&"
export * from "./TimelineBreaksArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports